<template>
  <b-modal ref="modalExportMercuComplementaire" size="lg" title="Exporter une mercuriale complementaire"
      ok-title="Fermer"
      :ok-only=true
      :hide-header-close="fichierEnCours"
      no-close-on-backdrop
      @show="initialiserModale()"
      @ok="fermerExport()">
      <template slot="default">
        <div style="display: inline">
          <div class="container-fluid card card-body">
            <div class="row ">
              <div class="col-12 form-group">
                Exporter la mercuriale complémentaire du fournisseur <b>{{ nomFournisseur }}</b> pour la famille <b>{{ nomFamille }}</b>
              </div>
            </div>
            <div class="row">
              <div class="col-6 form-group">
                  <label>Taux Mercuriale à appliquer sur le fichier</label>
                  <v-select v-model="mercurialeSelectionne" :options="optionsMercuriales" label="texte" value="valeur" :clearable="false" placeholder="Sélectionner une lettre de mercu"></v-select>
              </div>
            </div>
            <hr>
            <div class="row importFichier">
              <div class="col-10 aligner-droite"></div>
              <div class="col-2 aligner-droite">
                <button :disabled="!mercurialeSelectionne" class="btn btn-success" @click="exporterFichierMercu()">Exporter</button>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>
</template>

<script>

import { obtenirLettresMercuriales } from '@/api/gpao/mercuriales'
import { connecteData } from "@/mixins/connecteData"
import { formatageDate } from '@/mixins/dateFormats'

export default {
  name: "ModalExportMercuComplementaire",
  props: [ 'nomFournisseur', 'nomFamille' ],
  mixins: [ connecteData, formatageDate ],
  data() {
  return {
    optionsMercuriales: [],
    mercurialeSelectionne: {},
    }
  },
  watch: {
    
  },
  computed: {

  },
  methods: {

    async initialiserModale() {
      this.optionsMercuriales = await this.construireListeMercuriale()
    },
    async construireListeMercuriale() {
      let response = await obtenirLettresMercuriales()

      let liste = []
      let tmpLettre = response.data

      liste = tmpLettre.map((t) => {
        let rObj = {}
        rObj.valeur = t.lettre
        rObj.texte = t.lettre
        return rObj
      });

      return liste
    },
    
    controleAvantExport() {
      if (!this.mercurialeSelectionne) {
        this.alerteErreur("Le taux de mercuriale est obligatoire")
        return false
      }
      return true
    },
    async exporterFichierMercu() {
      if (!this.controleAvantExport())
        return

      //on appel l'évènement d'export de la page appelante, ça simplifi la gestion de cette modale :
      this.$emit("exporterMercuriale", this.mercurialeSelectionne)
    },
    fermerExport() {
      this.hide()  
    },
    show() {
      this.mercurialeSelectionne = null
      this.$refs.modalExportMercuComplementaire.show()
    },
    hide() {
      this.$refs.modalExportMercuComplementaire.hide()
    }
  }
}
</script>